/**
 * Controls definitions of styles properties
 *
 * @type {Array}
 */
const styleOptions = [{
    title: "Текст метки",
    name: "title",
    type: "text"
}, {
    title: "Шрифт метки",
    name: "textFont",
    type: "text"
}, {
    title: "Размер шрифта метки",
    name: "textFontSize",
    type: "range",
    min: 0,
    max: 50,
    step: 1,
    units: "px"
}, {
    title: "Цвет обводки шрифта",
    name: "textStrokeColor",
    type: "colorpicker",
    format: "rgbarray"
}, {
    title: "Толщина обводки шрифта",
    name: "textStrokeWidth",
    type: "range",
    min: 0,
    max: 100,
    step: 0.1
}, {
    title: "Цвет заливки шрифта",
    name: "textFillColor",
    type: "colorpicker",
    format: "rgbarray"
}, {
    title: "Цвет фона",
    name: "fillColor",
    type: "colorpicker",
    format: "rgbarray"
}, {
    title: "Цвет обводки",
    name: "strokeColor",
    type: "colorpicker",
    format: "rgbarray"
}, {
    title: "Толщина обводки",
    name: "strokeWidth",
    type: "range",
    min: 0,
    max: 100,
    step: 0.1
}, {
    title: "Шаблон начертания",
    name: "strokeDash",
    type: "array"
}, {
    title: "Стиль начертания",
    name: "strokeCap",
    type: "select",
    options: ["round", "butt", "square"]
}, {
    title: "Стиль соединения",
    name: "strokeJoin",
    type: "select",
    options: ["round", "bevel", "miter"]
}, {
    title: "Радиус иконки",
    name: "iconRadius",
    type: "range",
    min: 1,
    max: 100,
    step: 1
}, {
    title: "URL иконки",
    name: "iconUrl",
    type: "text"
}, {
    title: "Ширина иконки",
    name: "iconWidth",
    type: "range",
    min: 0,
    max: 100,
    step: 1
}, {
    title: "Высота иконки",
    name: "iconHeight",
    type: "range",
    min: 0,
    max: 100,
    step: 1
}];

export default styleOptions.slice();
